<template>
  <div class="mitu-special">
    <!-- 活动标题 -->
    <div v-wechat-title="'《迷途之光》周年心声-致信同路人'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' @loginSuccess="loginSuccess" :gameName="gameName"
      :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS="false"
      noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell'
      @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='1' @click="logon()"
      @onDownload="onDownload" />
    <div class="super_punch_clock_page" ref="bg">

      <div class="index" ref="myDiv">
        <div class="main" ref="myDiv0">
          <div :class="'letter letter-' + letterAni">
            <img src="https://download4.qcplay.com/qcgame-api/y3TSUjiiCXU7oN3LBkg2CGxNNhRWS54cJVPNGTD1.png">
          </div>
          <div :class="'btn-box btn-box-' + activity.is_get">
            <a href="javascript:;" @click="nextPage();"></a>
          </div>
          <div class="role-box">
            <div class="role-1" title="角色1-动画"></div>
            <div class="role-2" title="角色2-动画"></div>
            <div class="role-3" title="角色3-动画"></div>
            <div class="role-4" title="角色4-动画"></div>
            <div class="pen" title="笔-动画"></div>
          </div>          
        </div>
        <div class="buttble-box">
          <div class="buttble"
            style="width:24px; height:24px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:1.67501s, 1.67501s; -webkit-animation-duration:8.0649s, 8.0649s; -moz-animation-name:fade, rightTop; -moz-animation-delay:1.67501s, 1.67501s; -moz-animation-duration:8.0649s, 8.0649s;">
            <img src="https://download4.qcplay.com/snail/special/dot01.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.96199s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.96199s;" />
          </div>
          <div class="buttble"
            style="width:36px; height:36px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:1.47375s, 1.47375s; -webkit-animation-duration:10.85969s, 10.85969s; -moz-animation-name:fade, rightTop; -moz-animation-delay:1.47375s, 1.47375s; -moz-animation-duration:10.85969s, 10.85969s;">
            <img src="https://download4.qcplay.com/snail/special/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.39094s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.39094s;" />
          </div>
          <div class="buttble"
            style="width:50px; height:50px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.3837s, 2.3837s; -webkit-animation-duration:7.31807s, 7.31807s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.3837s, 2.3837s; -moz-animation-duration:7.31807s, 7.31807s;">
            <img src="https://download4.qcplay.com/snail/special/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>
          <div class="buttble"
            style="width:60px; height:60px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.0s, 2.0s; -webkit-animation-duration:5.7361s, 5.7361s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.0s, 2.0s; -moz-animation-duration:5.7361s, 5.7361s;">
            <img src="https://download4.qcplay.com/snail/special/dot01.png"
              style="-webkit-animation-name:clockwiseSpin; -webkit-animation-duration:4.10997s; -moz-animation-name:clockwiseSpin; -moz-animation-duration:4.10997s;" />
          </div>
          <div class="buttble"
            style="width:80px; height:80px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.08319s, 2.08319s; -webkit-animation-duration:12.834s, 12.834s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.08319s, 2.08319s; -moz-animation-duration:12.834s, 12.834s;">
            <img src="https://download4.qcplay.com/snail/special/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:11.50401s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:11.50401s;" />
          </div>
          <div class="buttble"
            style="width:50px; height:50px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.67501s, 2.67501s; -webkit-animation-duration:10.0649s, 10.0649s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.67501s, 2.67501s; -moz-animation-duration:10.0649s, 10.0649s;">
            <img src="https://download4.qcplay.com/snail/special/dot01.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.96199s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.96199s;" />
          </div>
          <div class="buttble"
            style="width:12px; height:12px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.47375s, 2.47375s; -webkit-animation-duration:12.85969s, 12.85969s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.47375s, 2.47375s; -moz-animation-duration:12.85969s, 12.85969s;">
            <img src="https://download4.qcplay.com/snail/special/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.39094s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.39094s;" />
          </div>
          <div class="buttble"
            style="width:35px; height:35px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.3837s, 2.3837s; -webkit-animation-duration:14.31807s, 14.31807s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.3837s, 2.3837s; -moz-animation-duration:14.31807s, 14.31807s;">
            <img src="https://download4.qcplay.com/snail/special/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>
          <div class="buttble"
            style="width:5px; height:5px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.67501s, 2.67501s; -webkit-animation-duration:10.0649s, 10.0649s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.67501s, 2.67501s; -moz-animation-duration:10.0649s, 10.0649s;">
            <img src="https://download4.qcplay.com/snail/special/dot01.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.96199s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.96199s;" />
          </div>
          <div class="buttble"
            style="width:12px; height:12px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.47375s, 2.47375s; -webkit-animation-duration:12.85969s, 12.85969s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.47375s, 2.47375s; -moz-animation-duration:12.85969s, 12.85969s;">
            <img src="https://download4.qcplay.com/snail/special/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.39094s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.39094s;" />
          </div>
          <div class="buttble"
            style="width:15px; height:15px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.3837s, 2.3837s; -webkit-animation-duration:14.31807s, 14.31807s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.3837s, 2.3837s; -moz-animation-duration:14.31807s, 14.31807s;">
            <img src="https://download4.qcplay.com/snail/special/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>
          <div class="buttble"
            style="width:100px; height:100px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:3.67501s, 3.67501s; -webkit-animation-duration:8.0649s, 8.0649s; -moz-animation-name:fade, rightTop; -moz-animation-delay:3.67501s, 3.67501s; -moz-animation-duration:8.0649s, 8.0649s;">
            <img src="https://download4.qcplay.com/snail/special/dot01.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:8.96199s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:8.96199s;" />
          </div>
          <div class="buttble"
            style="width:120px; height:120px; -webkit-animation-name:fade, rightTop; -webkit-animation-delay:2.3837s, 2.3837s; -webkit-animation-duration:7.31807s, 7.31807s; -moz-animation-name:fade, rightTop; -moz-animation-delay:2.3837s, 2.3837s; -moz-animation-duration:7.31807s, 7.31807s;">
            <img src="https://download4.qcplay.com/snail/special/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>

          <div class="buttble"
            style="width:70px; height:70px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.08319s, 2.08319s; -webkit-animation-duration:12.0649s, 12.0649s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.08319s, 2.08319s; -moz-animation-duration:12.0649s, 12.0649s;">
            <img src="https://download4.qcplay.com/snail/special/dot01.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:6.96199s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:6.96199s;" />
          </div>
          <div class="buttble"
            style="width:20px; height:20px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.3837s, 2.3837s; -webkit-animation-duration:8.85969s, 8.85969s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.3837s, 2.3837s; -moz-animation-duration:8.85969s, 8.85969s;">
            <img src="https://download4.qcplay.com/snail/special/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:6.39094s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:6.39094s;" />
          </div>
          <div class="buttble"
            style="width:60px; height:60px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:1.47375s, 1.47375s; -webkit-animation-duration:7.31807s, 7.31807s; -moz-animation-name:fade, leftTop; -moz-animation-delay:1.47375s, 1.47375s; -moz-animation-duration:7.31807s, 7.31807s;">
            <img src="https://download4.qcplay.com/snail/special/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>
          <div class="buttble"
            style="width:40px; height:40px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.58805s, 2.58805s; -webkit-animation-duration:4.7361s, 4.7361s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.58805s, 2.58805s; -moz-animation-duration:4.7361s, 4.7361s;">
            <img src="https://download4.qcplay.com/snail/special/dot01.png"
              style="-webkit-animation-name:clockwiseSpin; -webkit-animation-duration:3.10997s; -moz-animation-name:clockwiseSpin; -moz-animation-duration:3.10997s;" />
          </div>
          <div class="buttble"
            style="width:30px; height:30px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:1.67501s, 1.67501s; -webkit-animation-duration:6.834s, 6.834s; -moz-animation-name:fade, leftTop; -moz-animation-delay:1.67501s, 1.67501s; -moz-animation-duration:6.834s, 6.834s;">
            <img src="https://download4.qcplay.com/snail/special/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:5.50401s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:5.50401s;" />
          </div>
          <div class="buttble"
            style="width:50px; height:50px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.47375s, 2.47375s; -webkit-animation-duration:10.31807s, 10.31807s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.47375s, 2.47375s; -moz-animation-duration:10.31807s, 10.31807s;">
            <img src="https://download4.qcplay.com/snail/special/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>
          <div class="buttble"
            style="width:30px; height:30px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.58805s, 2.58805s; -webkit-animation-duration:12.7361s, 12.7361s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.58805s, 2.58805s; -moz-animation-duration:12.7361s, 12.7361s;">
            <img src="https://download4.qcplay.com/snail/special/dot01.png"
              style="-webkit-animation-name:clockwiseSpin; -webkit-animation-duration:3.10997s; -moz-animation-name:clockwiseSpin; -moz-animation-duration:3.10997s;" />
          </div>
          <div class="buttble"
            style="width:15px; height:15px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.67501s, 2.67501s; -webkit-animation-duration:14.834s, 14.834s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.67501s, 2.67501s; -moz-animation-duration:14.834s, 14.834s;">
            <img src="https://download4.qcplay.com/snail/special/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:5.50401s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:5.50401s;" />
          </div>
          <div class="buttble"
            style="width:5px; height:5px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.47375s, 2.47375s; -webkit-animation-duration:10.31807s, 10.31807s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.47375s, 2.47375s; -moz-animation-duration:10.31807s, 10.31807s;">
            <img src="https://download4.qcplay.com/snail/special/dot03.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:7.36608s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:7.36608s;" />
          </div>
          <div class="buttble"
            style="width:80px; height:80px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.58805s, 2.58805s; -webkit-animation-duration:12.7361s, 12.7361s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.58805s, 2.58805s; -moz-animation-duration:12.7361s, 12.7361s;">
            <img src="https://download4.qcplay.com/snail/special/dot01.png"
              style="-webkit-animation-name:clockwiseSpin; -webkit-animation-duration:3.10997s; -moz-animation-name:clockwiseSpin; -moz-animation-duration:3.10997s;" />
          </div>
          <div class="buttble"
            style="width:65px; height:65px; -webkit-animation-name:fade, leftTop; -webkit-animation-delay:2.67501s, 2.67501s; -webkit-animation-duration:14.834s, 14.834s; -moz-animation-name:fade, leftTop; -moz-animation-delay:2.67501s, 2.67501s; -moz-animation-duration:14.834s, 14.834s;">
            <img src="https://download4.qcplay.com/snail/special/dot02.png"
              style="-webkit-animation-name:counterclockwiseSpinAndFlip; -webkit-animation-duration:5.50401s; -moz-animation-name:counterclockwiseSpinAndFlip; -moz-animation-duration:5.50401s;" />
          </div>
        </div>
      </div>
      <div class="foot-page">
        <Footer :gameName="gameName" />
      </div>
    </div>

    <!-- 微信下载 -->
    <div class="wx_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="closePopup('wxLoadShow')"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="closePopup('wxLoadShow')"></div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Login from '@/components/login';
import Os from '@/components/os';
import Header from '../Header/index.vue';
import Footer from "@/components/Footer";
import { headerConfig } from '../headerConfig';
import { onGetInitDataAPI, rewardAPI } from '../api';
import { getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';

export default {
  name: 'special',
  components: {
    Header,
    Login,
    Os,
    Footer
  },
  data() {
    return {
      headerConfig,
      gameName: 'mzzg',
      is_access_token: '',
      downloadUrl: 'https://mtzg.qingcijoy.com/',
      loginTypes: ["sms", "password", "channel"],
      preventShow: false,
      open_link: '',
      wxLoadShow: false,
      isUserInfo: false,
      shareLink: '',
      user_info: {},
      activity: {},
      inviteSgin: true,
      letterAni: false,
      code_link: 'https://download4.qcplay.com/snail/special/reward_code_r.png',
    };
  },
  created() {
    // this.InitAni();
    this.initShareData();
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    // 埋点
    const bl = buriedLogger('mzzg', '迷途之光周年h5专题页');
    this.logger = bl;

    this.gethash();
    this.getUserInfo();
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        console.log('oldValue------>', oldValue)
        console.log('newValue------>', newValue)
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {

            if (!newValue.account) {
              // TAG: 注销的时候
              this.reInit()
            } else {
              console.log('登录成功')
              this.getUserInfo()
            }
          }
        }

      }
    },
  },
  methods: {
    gethash() {
      console.log(window.location);
    },
    InitAni() {
      setTimeout(() => {
        this.letterAni = true;
      }, 100);
    },
    logon() {
      this.changeLoginPopup(true);
    },
    initShareData() {
      const { protocol, host } = window.location;
      this.shareLink = `${protocol}//${host}/mitu/special/enter/${getRandomString()}`;
      this.$set(this, 'shareLink', this.shareLink)
      this.isSetShare(this.shareLink);
    },
    // 获取用户信息
    async getUserInfo() {
      const that = this
      await onGetInitDataAPI().then(response => {
        if (response.code === 200) {
          that.isUserInfo = true
          that.activity = response.data.activity;
          that.user_info = response.data.userinfo;
          that.onInitState(response);
          // 例如：获取好友助力信息等
        } else {
          that.isUserInfo = false;
          that.setInitUserInfo();
          that.setInitActiveInfo();
        }
        this.onToast(response.message);
      }).catch(() => {
        
      }).finally(() => {
        document.onvisibilitychange = null
      })
    },
    onInitState(response) {
      const { code } = response || {}
      if (response.code == 200) {
        console.log('初始化数据成功');
        this.setUserInfo(response.data.userinfo);
      }
      // 很抱歉，请先登录！
      if (response.code == 403) {
        this.changeLoginPopup(true);
      }
    },
    nextPage() {
        this.logger.sum('迷途之光_周年专题页_参与活动按钮')
        if (!this.checkLogin()) return
        this.rewardGift();
    },
    // 登录校验
    checkLogin() {
      if (!this.user_info.account) {
          this.changeLoginPopup(true)
          return false
      }
      return true
    },
    rewardGift() {
      const params = { ...this.userInfo }
      if(this.activity.is_get) {      
        this.logger.sum('迷途之光_周年专题页_已领取奖励');
        this.onToast('奖励已经领取过了，一起享受周年庆吧！')
        return
      }
      rewardAPI(params).then(res => {
        this.logger.sum('迷途之光_周年专题页_领取奖励');
        console.log('res------>', res);
        if (res.code === 200) {
          this.priceShow = true
          this.onToast(res.message)
          this.getUserInfo()
        } else {
          this.priceShow = false
          this.onToast(res.message)
        }
      })

    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.isUserInfo = false; // 是否获取到用户信息，用于判断是否显示登录弹窗等
      this.isLogin = false; // 是否登录，用于判断是否显示登录弹窗等
      this.isSelectRole = false; // 是否选择角色，用于判断是否显示选择角色弹窗等
      this.isSelectServer = false; // 是否选择服务器，用于判断是否显示选择服务器弹窗等
      this.helpSign = false;
      this.inviteSgin = true;
      this.activity = {},
      this.user_info = {},
      this.setInitUserInfo();
      this.setInitActiveInfo();
    },
    // 选择角色后
    selectCallback() {
      // 初始化
      this.sureShow = true
      this.getUserInfo();
    },
    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo
      selectInfo.account = this.userInfo.account
      this.setUserInfo(selectInfo);
    },
    loginSuccess() {
      this.changeOsPopup(true); // 开启账户绑定弹窗
    },
    reInit() {
      console.log('清除data里面相关数据')
      this.clearActiveInfo(); // 清除data里面相关数据
    },
    onDownload() {
      this.isWechatBrowser = wechatBrowser();
      if (this.isWechatBrowser) { // 在微信app下
        console.log('在微信app下');
        return this.wxLoadShow = true
      }
      // 获取URL参数
      const urlParams = new URLSearchParams(window.location.search);
      const type = urlParams.get('type');
      
      // 检测浏览器类型
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isAndroid = /android/i.test(userAgent);
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      
      // 根据类型和平台决定下载链接
      if (isAndroid) {
        if (type) {
          const apkLinks = [
            'https://download4.qcplay.com/apk-v2/qc-kol-1167813.apk',
            'https://download4.qcplay.com/apk-v2/qc-kol-1167814.apk',
            'https://download4.qcplay.com/apk-v2/qc-kol-1167815.apk',
            'https://download4.qcplay.com/apk-v2/qc-kol-1167816.apk',
            'https://download4.qcplay.com/market/apk/Tap_迷途之光_encrypted.apk'
          ];
          const index = Math.min(parseInt(type) - 1, 4);
          window.location.href = apkLinks[index];
        } else {
          window.location.href = 'https://download4.qcplay.com/market/apk/Tap_迷途之光_encrypted.apk';
        }
      } else if (isIOS) {
        window.location.href = 'https://apps.apple.com/cn/app/%E8%BF%B7%E9%80%94%E4%B9%8B%E5%85%89-%E8%B6%85%E7%88%BD%E8%82%89%E9%B8%BD%E5%83%8F%E7%B4%A0%E5%BC%B9%E5%B9%95%E5%B0%84%E5%87%BB/id6479300771';
      }
      this.logger.sum('迷途之光_周年专题页_前往下载');
    },
    // 区组弹窗注销-相关参数复位
    osCancell() { },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // TAG: 其他简易封装的方法
    openPopup(name) {
      if (!this.isUserInfo) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      this[name] = true;
    },
    closePopup(name) {
      this[name] = false;
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/mitu/special/enter${getRandomString()}`,
        title: '《迷途来信》',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/sHy3g7GVa1k050VckwFS9vLdVgjWchM37Mo6nFq9.png',
        desc: '一封诚意满满的无套路信件，阅读即领周年福利！'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/mitu/special/index/index.vue